// src/components/Footer.js
import React from "react";
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-dark text-white text-center p-3 mt-4">
      <p>© {new Date().getFullYear()} {t("copyright")}</p>
    </footer>
  );
};

export default Footer;
